import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

// Dashboards
import AdminTrackerDashboard from './admin/AdminTrackerDashboard';
import GateGuardDashboard from './gate/GateGuardDashboard';
import SupervisorDashboard from './production/SupervisorDashboard';
import QualityDashboard from './quality/QualityDashboard';
import StoreDashboard from './store/StoreDashboard';
import SalesDashboard from './sales/SalesDashboard';
import FinanceDashboard from './finance/FinanceDashboard';
import DispatchDashboard from './dispatch/DispatchDashboard';
import AssemblyDashboard from './assembly/AssemblyDashboard';


const Dashboard = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Handle custom permissions for 'user' role
  if (user.role === 'user' && user.permissions && user.permissions.length > 0) {
    if (user.permissions.includes('supervisor')) return <SupervisorDashboard />;
    if (user.permissions.includes('quality_checker')) return <QualityDashboard />;
    if (user.permissions.includes('gate_guard')) return <GateGuardDashboard />;
    if (user.permissions.includes('store_manager')) return <StoreDashboard />;
    if (user.permissions.includes('sales')) return <SalesDashboard />;
    if (user.permissions.includes('purchase') || user.permissions.includes('purchase_user') || user.permissions.includes('purchase_manager') || user.permissions.includes('finance')) return <FinanceDashboard />;
    if (user.permissions.includes('assembly') || user.permissions.includes('assembly_user') || user.permissions.includes('assembly_manager')) return <AssemblyDashboard />;
    if (user.permissions.includes('dispatch')) return <DispatchDashboard />;

  }

  // Render dashboard based on role
  switch (user.role) {
    case 'super_admin':
    case 'admin':
      return <AdminTrackerDashboard />;
    case 'gate_guard':
      return <GateGuardDashboard />;
    case 'supervisor':
    case 'production_manager':
      return <SupervisorDashboard />;
    case 'quality_checker':
      return <QualityDashboard />;
    case 'store_manager':
      return <StoreDashboard />;
    case 'sales':
      return <SalesDashboard />;
    case 'purchase_manager':
    case 'purchase_user':
      return <FinanceDashboard />;
    case 'assembly':
    case 'assembly_user':
    case 'assembly_manager':
      return <AssemblyDashboard />;
    case 'dispatch':
    case 'dispatch_manager':
      return <DispatchDashboard />;

    default:
      return (
        <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', background: '#0a0e1a', color: '#fff' }}>
          <div>
            <h3>Welcome to Factory Automation ERP</h3>
            <p>Your account role "{user.role}" does not have a designated dashboard workspace yet. Please contact your administrator.</p>
          </div>
        </div>
      );
  }
};

export default Dashboard;
